<template>
  <div>
    <div
      v-for="(item, index) in list"
      :key="index"
      class="audio-content"
      @click="goDetail(item.uuid, 'type')"
    >
      <span class="title" v-html="item.title"></span>
      <van-image
        width="20"
        height="3"
        class="line-img"
        :src="require('@/assets/line.png')"
      />
      <span class="desc">{{ item.summary }}</span>
      <span class="time">{{ Number(item.create_time) | datetimeFormat }}</span>
    </div>
    <van-dialog
      v-model="show"
      title=""
      width="798"
      className="audio-info"
      :showConfirmButton="false"
      closeOnClickOverlay
      :beforeClose="beforeCloseAudio"
    >
      <div>
        <div>
          <span class="title">{{ detail.title }}</span>
          <van-image
            width="20"
            height="3"
            class="line-img"
            :src="require('@/assets/line.png')"
          />
          <span class="desc">{{ detail.summary }}</span>
          <div>
            <audio-new ref="audioNew" :fileurl="detail.audio_url"></audio-new>
            <!-- <audio controls class="audio-control">
              <source :src="require('@/assets/1.mp3')" />

              您的浏览器不支持音频播放
            </audio> -->
          </div>
        </div>
      </div>

      <van-image
        width="36"
        height="36"
        class="close-img"
        @click="closeDialog"
        :src="require('@/assets/close.png')"
      />
    </van-dialog>
  </div>
</template>
<script>
import AudioNew from "./Audio.vue";
export default {
  components: {
    AudioNew,
  },
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {
      show: false,
      detail: {},
    };
  },
  methods: {
    goDetail(id) {
      this.getDetail(id);
      this.show = true;
    },
    async getDetail(id) {
      try {
        const { data } = await this.$axios.post(`Articleeducate/getDetail`, {
          id: id,
          type: 3,
        });
        this.detail = data;
      } catch (error) {
        this.$toast(error?.errorMSg ?? "暂无数据");
      } finally {
        this.loading = false;
      }
    },
    closeDialog() {
      this.$refs.audioNew.pauseAudio();
      this.show = false;
    },
    beforeCloseAudio() {
      this.$refs.audioNew.pauseAudio();
      this.show = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.audio-content {
  display: inline-block;
  width: 538px;
  height: 237px;
  margin-top: 30px;
  margin-left: 43px;
  cursor: pointer;
  border: 1px solid #0047ff;

  .title {
    display: -webkit-box; /* stylelint-disable-line */
    display: -ms-flexbox; /* stylelint-disable-line */
    width: 460px;
    height: 55px;
    margin-top: 27px;
    margin-left: 40px;
    overflow: hidden;
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
    color: #333;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;

    ::v-deep span {
      color: rgb(0 71 255 / 100%);
    }
  }

  .line-img {
    margin-top: 20px;
    margin-left: 40px;
  }

  .desc {
    display: -webkit-box; /* stylelint-disable-line */
    display: -ms-flexbox; /* stylelint-disable-line */
    width: 460px;
    height: 55px;
    margin-top: 19px;
    margin-left: 40px;
    overflow: hidden;
    font-size: 14px;
    font-weight: 400;
    line-height: 25px;
    color: #333;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .time {
    display: inline-block;
    margin-top: 20px;
    margin-left: 40px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
  }
}

.audio-info {
  overflow: inherit;
  background: white;
  border: 3px solid #0047ff;
  border-radius: 0;

  .title {
    display: -webkit-box; /* stylelint-disable-line */
    display: -ms-flexbox; /* stylelint-disable-line */
    width: 724px;
    height: 55px;
    margin-top: 27px;
    margin-left: 40px;
    overflow: hidden;
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
    color: #333;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .line-img {
    margin-top: 20px;
    margin-left: 40px;
  }

  .desc {
    display: -webkit-box; /* stylelint-disable-line */
    display: -ms-flexbox; /* stylelint-disable-line */
    width: 724px;
    height: 54px;
    margin-top: 19px;
    margin-left: 40px;
    overflow: hidden;
    font-size: 14px;
    font-weight: 400;
    line-height: 25px;
    color: #333;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .audio-control {
    width: 100%;
    height: 30px;
  }

  .close-img {
    position: absolute;
    top: -2px;
    right: -36px;
    cursor: pointer;
  }
}
</style>
